import {
  ActionType,
  BreakfastPayload,
  AbsenceResponse,
} from "models/dashboard/breakfast";

export const getBreakfastAction = (payload: BreakfastPayload) => {
  return {
    type: ActionType.GET_BREAKFAST_CHART,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_BREAKFAST_CHART_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: AbsenceResponse) => {
  return {
    type: ActionType.GET_BREAKFAST_CHART_SUCCESS,
    payload,
  };
};
